'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//换肤颜色算法
exports.default = function createColorComputed() {
  var lightColorCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

  //获取色相
  var getHue = function getHue(hsv, i, isLight) {
    var hueStep = 2;
    var hue = void 0;
    if (hsv.h >= 60 && hsv.h <= 240) {
      // 冷色调
      // 减淡变亮 色相顺时针旋转 更暖
      // 加深变暗 色相逆时针旋转 更冷
      hue = isLight ? hsv.h - hueStep * i : hsv.h + hueStep * i;
    } else {
      // 暖色调
      // 减淡变亮 色相逆时针旋转 更暖
      // 加深变暗 色相顺时针旋转 更冷
      hue = isLight ? hsv.h + hueStep * i : hsv.h - hueStep * i;
    }
    return hue;
  };
  var getSaturation = function getSaturation(hsv, i, isLight) {
    // getSaturation 获取饱和度渐变
    var saturationStep = 16;
    var saturationStep2 = 5;
    var darkColorCount = 4;
    var saturation = void 0;
    if (isLight) {
      // 减淡变亮 饱和度迅速降低
      saturation = Math.round(hsv.s * 100) - saturationStep * i;
    } else if (i == darkColorCount) {
      // 加深变暗-最暗 饱和度提高
      saturation = Math.round(hsv.s * 100) + saturationStep;
    } else {
      // 加深变暗 饱和度缓慢提高
      saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
    }
    return saturation;
  };
  var getValue = function getValue(hsv, i, isLight) {
    // getValue 获取明度渐变
    var brightnessStep1 = 5;
    var brightnessStep2 = 15;
    if (isLight) {
      // 减淡变亮
      return Math.round(hsv.v * 100) + brightnessStep1 * i;
    }
    // 加深变暗幅度更大
    return Math.round(hsv.v * 100) - brightnessStep2 * i;
  };
  return function (color) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

    //边界值处理
    if (!color) {
      this.console('warn', 'colorComputed params must be require');
      return;
    }
    var isLight = index <= 6;
    var hsv = (0, _tinycolor2.default)(color).toHsv();
    var i = isLight ? lightColorCount + 1 - index : index - lightColorCount - 1;
    // i 为index与6的相对距离
    return (0, _tinycolor2.default)({
      h: getHue(hsv, i, isLight),
      s: getSaturation(hsv, i, isLight),
      v: getValue(hsv, i, isLight)
    }).toHexString();
  };
}();